const MPH_PER_METERS_PER_SECOND = 2.23694;

/**
 * Converts speed from meters per second to miles per hour, rounded to two decimal places.
 */
export function metersPerSecondToMph(metersPerSecond: number): number {
    return Math.round(metersPerSecond * MPH_PER_METERS_PER_SECOND * 100) / 100;
}

export function mphToMetersPerSecond(mph: number): number {
    return Math.round((mph / MPH_PER_METERS_PER_SECOND) * 100) / 100;
}
